import PropTypes from "prop-types";
import React from "react";
import { ConnectedWsSessionStatus } from "ui/ws-session-status/connected-ws-session-status";
import Footer from "view/layout/footer";

class Page extends React.Component {
  static get displayName() {
    return "Page";
  }

  static get propTypes() {
    return {
      className: PropTypes.string,
      breadcrumbs: PropTypes.node,
      children: PropTypes.node,
      desc: PropTypes.node,
      title: PropTypes.node,
      toolbox: PropTypes.node,
    };
  }

  static get defaultProps() {
    return {
      className: "",
    };
  }

  render() {
    const { breadcrumbs, children, className, desc, title, toolbox } =
      this.props;

    return (
      <div className={`content-wrapper ${className}`}>
        {breadcrumbs && (
          <section className="content-nav">{breadcrumbs}</section>
        )}
        <section className="content-header">
          {title && (
            <h1>
              {title} <small>{desc}</small>
            </h1>
          )}
          {toolbox}
          <div className="clearfix" />
        </section>
        <section className="content">
          <section className="session-status">
            <ConnectedWsSessionStatus />
          </section>
          {children}
        </section>
        <Footer />
      </div>
    );
  }
}

export default Page;
export { Page };
